export class Address {
  static from = (address: string): Address => {
    return new Address(address.toLowerCase()).normalize();
  };

  private constructor(private readonly address: string) {}

  toString = (): string => {
    return this.address;
  };

  equals = (other: Address): boolean => {
    return this.address === other.address;
  };

  normalize = (): Address => {
    if (!this.address || this.address === "0x" || this.address === "0x0") {
      return new Address("0x0000000000000000000000000000000000000000000000000000000000000000");
    }

    // Handle structured addresses (e.g., "0x1::aptos_coin::AptosCoin")
    if (this.address.includes("::")) {
      const parts = this.address.split("::");
      const hexPart = parts[0].replace(/^0x/, "").toLowerCase().padStart(64, "0");
      return new Address(`0x${hexPart}::${parts.slice(1).join("::")}`);
    }

    // Handle regular hex addresses
    const hex = this.address.replace(/^0x/, "").toLowerCase().padStart(64, "0");
    return new Address(`0x${hex}`);
  };
}

/**
 * Check if an address is valid (not empty, not "0x", not "0x0")
 */
export const isValidAddress = (address?: string | null): address is string => {
  return !!address && address !== "0x" && address !== "0x0";
};
